"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPARE_LIMIT = void 0;
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const Types_1 = require("@/Types");
const Breadcrumbs_1 = __importDefault(require("@/Components/Block/Breadcrumbs/Breadcrumbs"));
const ProductListing_1 = __importDefault(require("./ProductListing/ProductListing"));
const ProductCompare_1 = __importDefault(require("./ProductCompare/ProductCompare"));
const RotatingLoader_1 = __importDefault(require("@/Components/UI/RotatingLoader/RotatingLoader"));
const Hooks_1 = require("@/Hooks");
const Utils_1 = require("@/Utils");
const ProductCatalogLanguageSelector_1 = __importDefault(require("@/Components/ProductCatalogLanguageSelector"));
const styled_1 = require("@/Components/Variation/VariationItemContent/styled");
const Typography_1 = __importStar(require("app/Components/UI/Typography"));
exports.COMPARE_LIMIT = 4;
const FamilyPage = ({ name, parentUrl, description, imageUrl, children, breadcrumbs }) => {
    const { isDesktopSmall4, isMobile } = (0, Hooks_1.useDevice)();
    const initialData = (0, Hooks_1.useInitialData)();
    const INITIAL_PAGESIZE = isMobile ? 4 : 20;
    const { filters, families, productsAmount, error, isFamilyLoading, familyPageState, setFamilyPageState, setListingPageState, setSavedListingFilters, newPageSize, setNewPageSize, setFilterParam, breadcrumbs: familyBreadcrumbs, name: familyName, description: familyDescription } = (0, Hooks_1.useFamilyData)();
    const { onCompareProducts, compareProducts, setCompareProducts, isCompareLoading, compareProductPartNumbers, setCompareProductPartNumbers } = (0, Hooks_1.useCompareProducts)(setFamilyPageState, setSavedListingFilters);
    (0, react_1.useEffect)(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        if (urlSearchParams.has(Hooks_1.COMPARE_PARAM) && !isDesktopSmall4) {
            const productNumbers = urlSearchParams.get(Hooks_1.COMPARE_PARAM);
            const productNumbersArray = productNumbers.split(',');
            if (initialData === null || initialData === void 0 ? void 0 : initialData.continent) {
                setCompareProductPartNumbers(productNumbersArray);
                setFamilyPageState(Types_1.EFamilyPageStates.COMPARE);
                onCompareProducts(productNumbersArray);
                window.history.replaceState({}, '', `${window === null || window === void 0 ? void 0 : window.location.pathname}?${Hooks_1.COMPARE_PARAM}=${productNumbers}`);
            }
        }
        else {
            setFamilyPageState(Types_1.EFamilyPageStates.LISTING);
            window.history.replaceState({}, '', `${window === null || window === void 0 ? void 0 : window.location.pathname}`);
        }
    }, [initialData === null || initialData === void 0 ? void 0 : initialData.continent]);
    return (react_1.default.createElement(styled.Container, null, !families && isFamilyLoading ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Breadcrumbs_1.default, { breadcrumbs: familyBreadcrumbs || breadcrumbs }),
        react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.H1 }, familyName),
        react_1.default.createElement(styled.LoadingContainer, null,
            react_1.default.createElement(RotatingLoader_1.default, null)))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Breadcrumbs_1.default, { breadcrumbs: familyBreadcrumbs || breadcrumbs }),
        isMobile && react_1.default.createElement(ProductCatalogLanguageSelector_1.default, { Wrapper: styled_1.LanguagesSelectorWrapper }),
        familyPageState === Types_1.EFamilyPageStates.COMPARE && (react_1.default.createElement(ProductCompare_1.default, { compareProducts: compareProducts, setCompareProducts: setCompareProducts, setCompareProductPartNumbers: setCompareProductPartNumbers, setListingPageState: setListingPageState, isCompareLoading: isCompareLoading })),
        familyPageState === Types_1.EFamilyPageStates.LISTING && (react_1.default.createElement(ProductListing_1.default, { name: familyName || name, description: familyDescription || description, previousPageLink: (0, Utils_1.getPreviousPageLink)(breadcrumbs), imageUrl: imageUrl, parentUrl: parentUrl, families: families, productsAmount: productsAmount, filters: filters, setFilterParam: setFilterParam, newPageSize: newPageSize, setNewPageSize: setNewPageSize, initialPageSize: INITIAL_PAGESIZE, isFamilyLoading: isFamilyLoading, compareProductPartNumbers: compareProductPartNumbers, setCompareProductPartNumbers: setCompareProductPartNumbers, onCompareProducts: onCompareProducts, error: error, isCompareLoading: isCompareLoading, breadcrumbs: familyBreadcrumbs || breadcrumbs }, children))))));
};
exports.default = FamilyPage;
